import { game } from "native";

import { getAccountType, isAppFeatureEnabled, getRestrictionTimeLeftTooltip } from "commerce/lib/account-details";

import { activeQuote } from "stores/active-quote";

import { notMouseEvent } from "./mouse-events";
import { get }           from "svelte/store";

function showTooltip(e, text) {
    if (notMouseEvent(e)) {
        if (e.target.getAttribute("hide-tooltip")) {
            return game.call("HideTextTooltip");
        }

        if (!e.relatedTarget.getAttribute("hide-tooltip")) {
            return;
        }
    }

    if (!text) {
        game.call("HideTextTooltip");

        return;
    }

    game.call("ShowTextTooltip", text);
}

function getTooltipText({ featureDisabled, exchangeType } = {}) {
    const i18n = window.strings;

    if (featureDisabled) {
        const features    = GW2.config.features;
        const accountType = getAccountType();

        if (exchangeType in features && !features[exchangeType]) {
            return i18n.disabled.feature;
        }

        // Other states just return the string
        return accountType === "restricted" ?
            getRestrictionTimeLeftTooltip(i18n) :
            i18n.disabled[accountType];
    }

    if (get(activeQuote).disabled) {
        return isAppFeatureEnabled("billing") ?
            i18n.exchange.needFunds :
            i18n.exchange.insufficient[exchangeType];
    }

    return "";
}

export {
    showTooltip,
    getTooltipText
};
